<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    :style="{
      '--schema-color': schemaPrimaryColor,
    }"
    class="select-container"
  >
    <div
      v-if="!fullScreenLoading && businessEntity != null"
      class="header mt-70"
    >
      <div
        class="header-logo"
        v-if="businessEntity.logo"
      >
        <img
          :src="
            `https://tippiie-images.s3.eu-central-1.amazonaws.com/public/${
              businessEntity.logo
            }?t=${new Date().getTime()}`
          "
          alt="Tippie"
        >
        <h2>{{ businessEntity.name }}</h2>
      </div>
      <p class="header-title">
        {{ $t("teams.choose-pooling-team") }}
      </p>
    </div>
    <div
      v-if="!fullScreenLoading && teams.length"
      class="body"
    >
      <div class="body-search-form">
        <el-input
          class="body-search-form-input"
          :placeholder="$t('teams.search-team')"
          prefix-icon="el-icon-search"
          v-model="search"
          clearable
          :style="{
            '--schema-color': schemaPrimaryColor,
          }"
        />
      </div>
      <div class="teams">
        <el-row
          v-for="(team, index) in filteredTeams"
          :key="index"
        >
          <router-link
            :to="{
              name: 'Pay',
              params: {
                qrCode: team.qrCode,
                currency: $route.params.currency || 'EUR',
                poolingPayment: true,
              },
            }"
            class="team"
          >
            <h3 class="team-name">
              {{ team.name }}
            </h3>
          </router-link>
        </el-row>
        <div
          v-if="this.teams && filteredTeams.length === 0"
          class="no-results"
        >
          <h3 class="no-results-title">
            {{ $t("select-employee.no-results-title") }}
          </h3>
          <p class="no-results-subtitle">
            {{ $t("select-employee.no-results-subtitle") }}
          </p>
        </div>
      </div>
      <el-row class="body-logo">
        <el-link
          class="body-logo-image-link"
          :underline="false"
          href="https://tippie.de"
        >
          <img
            src="@/assets/img/logo.png"
            alt="Tippie"
          >
        </el-link>
        <el-link
          :underline="false"
          class="body-logo-text-link"
          href="https://tippie.de"
        >
          {{ $t("visit-us") }}
        </el-link>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SelectTeam",
  data: () => ({
    fullScreenLoading: true,
    search: "",
    businessEntity: {},
    teams: [],
  }),
  computed: {
    schemaPrimaryColor() {
      return this.businessEntity.schemaPrimaryColor || "#FF8A00";
    },
    filteredTeams() {
      const searchText = this.search.toLowerCase();
      const filtered =  this.teams
        .filter((team) => team.name.toLowerCase().includes(searchText))
        .sort(function(a, b) {
          return a.name.toLowerCase() > b.name.toLowerCase()
            ? 1
            : a.name.toLowerCase() === b.name.toLowerCase()
            ? 0
            : -1;
        });

        return filtered.filter(el => !el.hideOnSelectTeamPage && el.qrCode !== 2107005)
    },
  },
  created() {
    const groupQrCode = parseInt(this.$route.params.groupQrCode);

    if (!groupQrCode) {
      this.$message.error(this.$t("form.something-wrong"));
      this.fullScreenLoading = false;
      return;
    }

    axios
      .get(
        `${process.env.VUE_APP_ADMIN_API_BASE_URL}/api/v1/teams/pools/${groupQrCode}`
      )
      .then((res) => {
        if (res.data?.businessEntity) {
          this.teams = res.data.teams;
          this.businessEntity = res.data.businessEntity;
          if (this.checkRedirect()) return;
          this.fullScreenLoading = false
        }
      })
      .catch((e) => console.log(e))
  },
  methods: {
    checkRedirect() {
      const DESIGN_URL = process.env.VUE_APP_NEW_DESIGN_PAYMENT_URL;
      if (this.businessEntity.newDesignPayment && DESIGN_URL) {
        window.location.href = `${DESIGN_URL}/select-team/${this.$route.params.groupQrCode}/${this.$route.params.currency}`;
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.select-container {
  max-width: 1024px;
  margin: 0 auto;
}

.header {
  margin-bottom: 25px;

  &-logo {
    text-align: center;

    img {
      width: 100px;
      height: auto;
      border-radius: 50%;
    }
  }

  &-title {
    color: #2d2e2f;
    font-family: "Raleway Medium", serif;
    font-size: 16px;
    text-align: center;
  }
}

.body {
  padding: 0 12px;

  &-multiple {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 20px 0;

    &__title {
      margin: 0 10px 0 0;
    }
  }

  .teams {
    .team {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e3e5e5;
      color: #2d2e2f;
      padding: 16px 10px;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        background-color: var(--schema-color);
        color: #fff;

        .team-name {
          color: #fff;
        }
      }

      &-name {
        color: #2d2e2f;
        font-weight: 600;
        margin: 0;
      }

      &-checkbox {
        width: 20px;
        height: 20px;
        background: #ffffff;
        border: 3px solid #fff;
        border-radius: 50%;
        box-shadow: 0 0 0 1px var(--schema-color);
        margin: 0 30px 0 auto;

        &.checked {
          background: var(--schema-color);
        }
      }
    }
  }

  &-search-form {
    margin-bottom: 15px;

    &-input::v-deep {
      input {
        border-radius: 8px;
        font-family: "Raleway Medium", serif;
        color: #2d2e2f;

        &:focus {
          border: 1px solid var(--schema-color);
        }
      }
    }
  }

  .no-results {
    margin-top: 100px;
    margin-bottom: 100px;
    text-align: center;

    &-title {
      margin-bottom: 8px;
      font-family: "Raleway Bold", serif;
      font-size: 24px;
      color: #2d2e2f;
    }

    &-subtitle {
      margin: 0;
      font-family: "Raleway Medium", serif;
      font-size: 16px;
      color: #b5b5b5;
    }
  }

  &-logo {
    text-align: center;
    margin-top: 40px;
    display: flex;
    flex-direction: column;

    img {
      width: 100px;
      height: 60px;
    }

    a {
      width: max-content;
      margin: 0 auto 10px auto;
    }

    &-image-link {
      width: auto;
      margin: 0 auto;
    }

    &-text-link {
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      width: auto;
      margin: 10px auto 0 auto;
    }
  }
}
</style>
<style lang="scss">
.el-switch.is-checked .el-switch__core {
  background: var(--schema-color);
  border: 1px solid var(--schema-color);
}
</style>
